export const emptyStudentForm = {
  firstName: "",
  lastName: "",
  email: "",
  grade: "",
  age: "",
};

export const normalizeStudent = (student = {}) => ({
  id: student._id || student.id || student.studentId || "",
  studentCode: student.studentCode || "",
  firstName: student.firstName || "",
  lastName: student.lastName || "",
  email: student.email || "",
  grade: student.grade ? String(student.grade) : "",
  age: student.age ?? "",
  teacherProfileId: student.teacherProfileId || null,
  parentProfileId: student.parentProfileId || null,
  pinResetAt: student.pinResetAt || null,
  active: student.active !== false,
  createdAt: student.createdAt || "",
  updatedAt: student.updatedAt || "",
});

export const normalizeStudentListResponse = (response = {}) => {
  const students = response?.data?.students || [];
  return students.map(normalizeStudent);
};

export const normalizeStudentDetailsResponse = (response = {}) => {
  return normalizeStudent(response?.data?.student || response?.data?.studentProfile || response?.data || {});
};

export const normalizeCreatedStudentResponse = (response = {}) => {
  const studentProfile = response?.data?.studentProfile || {};
  return {
    student: normalizeStudent({
      ...studentProfile,
      _id: studentProfile.id || response?.data?.studentId,
      studentCode: response?.data?.studentCode,
    }),
    credentials: {
      studentCode: response?.data?.studentCode || "",
      pin: response?.data?.pin || "",
      email: studentProfile.email || "",
    },
  };
};

export const buildStudentPayload = (formData) => ({
  firstName: formData.firstName.trim(),
  lastName: formData.lastName.trim(),
  email: formData.email.trim(),
  grade: String(formData.grade).trim(),
  age: Number(formData.age),
});

export const buildStudentUpdatePayload = (formData) => ({
  firstName: formData.firstName.trim(),
  lastName: formData.lastName.trim(),
  email: formData.email.trim(),
  grade: String(formData.grade).trim(),
  age: Number(formData.age),
});

export const studentToFormData = (student) => ({
  firstName: student?.firstName || "",
  lastName: student?.lastName || "",
  email: student?.email || "",
  grade: student?.grade || "",
  age: student?.age === 0 || student?.age ? String(student.age) : "",
});

export const getStudentDisplayName = (student) => {
  const fullName = `${student?.firstName || ""} ${student?.lastName || ""}`.trim();
  return fullName || "Student";
};

export const getStudentErrorMessage = (message = "") => {
  if (/not authorized|unauthorized|forbidden/i.test(message)) {
    return "Please sign in through Teachers & Parents to manage students.";
  }

  return message || "Something went wrong while loading students.";
};
